import React, { Component } from 'react';
import BannerItem from "../../component/pc/BannerItem";
import BannerBtn from "../../component/pc/BannerBtn";
import { Link } from 'react-router-dom';

class Banner extends Component {
    constructor(props) {
        super(props);
        this.bannerCount = 0;
        this.state = {
            style:{
                width:0,
                left:0
            },
            bannerIndex: 0
        };
    }

    changeSlide () {
        const nextBannerIndex = (this.state.bannerIndex + 1) % this.bannerCount;
        this.setState((state) => {
            return { bannerIndex: nextBannerIndex };
        });
        this.goBanner(nextBannerIndex);
    }

    componentDidMount () {
        this.interval = setInterval(() => this.changeSlide(), 5000);
    }

    componentWillUnmount () {
        clearInterval(this.interval);
    }

    setBannerCss = () => {
        let re_banner_rolling = document.querySelector('.re_banner_rolling');
        this.state.style.width = 1170 * this.bannerCount;
        re_banner_rolling.style.width = `${this.state.style.width}px`;
        re_banner_rolling.style.transition = 'left 0.3s';
    };

    goBanner = (index) => {
        const rebannerBtnItem = document.getElementsByClassName('re_banner_btn');
        if (rebannerBtnItem.length > 0) {
            for (let i = 0; i < this.bannerCount; i++) {
                rebannerBtnItem[i].className = 're_banner_btn';
            }
            rebannerBtnItem[index].className = 're_banner_btn current';

            const reBannerRolling = document.querySelector('.re_banner_rolling');
            this.state.style.left = 1170 * index * -1;
            reBannerRolling.style.left = `${this.state.style.left}px`;
        }
    };

    render () {
      if (document.getElementsByClassName("re_banner_btn")[0]) {
        this.bannerCount = document.getElementsByClassName('re_banner_btn').length;
        this.setBannerCss();
        this.goBanner(0);
      }

      let bannerList = [];
      let bannerBtnArea = (<></>);
      if (this.props.currentEventInfo && Array.isArray(this.props.currentEventInfo.bannerList)) {
        bannerList = this.props.currentEventInfo.bannerList.filter(x => x.pcBannerExposeyn === 'Y');
      }

      if (bannerList.length === 0) {
        return <></>;
      } else {
        const bannerItem = data => {
          return data.map((banner, i)=>{
            if (banner.pcBannerExposeyn === 'Y') {
              return (<BannerItem banner={banner} key={i} />);
            }
          });
        };

        const bannerBtn = data => {
          return data.map((banner, i)=>{
            if (banner.pcBannerExposeyn === 'Y') {
              return (<BannerBtn banner={banner} key={i} goBanner={() => this.goBanner(i)}/>);
            }
          });
        };

        if (bannerList.length>1) {
          bannerBtnArea =(<div className="re_banner_btns">
                              {bannerBtn(bannerList)}
                          </div>);
        }

        return (<div className="re_banner_w">
                    <div className="re_banner_rolling">
                        {bannerItem(bannerList)}
                    </div>
                    {bannerBtnArea}
                </div>);
      }
    }
}

export default Banner;
